import React, { useState } from 'react';
import { Form } from 'antd';
import img_checked from '@/assets/img/img_checked.png';
import img_uncheck from '@/assets/img/img_uncheck_v2.png';
import img_disable from '@/assets/img/img_checked_disable.png'
import { use } from 'react';
import { useEffect } from 'react';

const ImageCheckbox = ({ checked, onChange, imageUrl, label }) => (
  <div
    className='flex items-center flex-1 cursor-pointer'
    onClick={() => onChange(!checked)}
  >
    <img className='w-16px mr-12px' src={checked ? img_checked : img_uncheck} alt={label} />
    <span className='text-14px text-[#000]'>{label}</span>
  </div>
);

const ImageCheckboxGroup = (props) => {
  
  const { options, onChange, form, value } = props
  // const value = form.getFieldValue('input_func')
  console.log('value is', value)
  const [selectedValues, setSelectedValues] = useState([]);

  useEffect(() => {
    Array.isArray(value) && setSelectedValues(value)
    
  }, [value])

   console.log('selectedValues is', selectedValues)
  const handleCheckboxChange = (optionValue) => {
    let newValue;
    if (selectedValues.includes(optionValue)) {
      newValue = selectedValues.filter((value) => value !== optionValue);
    } else {
      newValue = [...selectedValues, optionValue];
    }
    setSelectedValues(newValue);
    // if (!newValue.includes('1')) {
    //   form.setFieldValue('saylist_detail', [])
    // }
    onChange(newValue); // Notify parent component about the change.
    
    console.log("new value is", newValue)
  };

  return (
    <div className='flex'>
      {options.map(({ label, value, imageUrl }) => (
        <ImageCheckbox
          key={value}
          checked={selectedValues.includes(value)}
          onChange={() => handleCheckboxChange(value)}
          imageUrl={imageUrl}
          label={label}
        />
      ))}
    </div>
  );
};

// 导出经过 Form.Item 包装的组件
const ImageCheckboxGroupFormItem = (props) => {
  console.log('props is', props)
  return (
    <Form.Item 
      name={props.name}
      valuePropName="checked" // 关键点：这里指定 valuePropName
      {...props}
    >
      <ImageCheckboxGroup {...props} />
    </Form.Item>
  );
};


export default ImageCheckboxGroupFormItem;